var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { NAMESPACE } from '../../config/app.constants';
import { Locale } from '../Intl';
import { BrowserRouter } from '../BrowserRouter';
import { Provider as LoggerProvider } from '../Logger';
function EntryPoint(_a) {
    var children = _a.children, locale = _a.locale, historyListeners = _a.historyListeners;
    return (_jsx(LoggerProvider, __assign({ namespace: NAMESPACE }, { children: _jsx(Locale.Provider, __assign({ locale: locale }, { children: _jsx(BrowserRouter, __assign({ listeners: historyListeners || [] }, { children: children }), void 0) }), void 0) }), void 0));
}
export default EntryPoint;
//# sourceMappingURL=Component.js.map